module.exports = {"110113001":"胜利街道","110113002":"光明街道","110113003":"仁和地区","110113004":"后沙峪地区","110113005":"天竺地区","110113006":"杨镇地区","110113007":"牛栏山地区","110113008":"南法信地区","110113009":"马坡地区","110113010":"石园街道","110113011":"空港街道","110113012":"双丰街道","110113013":"旺泉街道","110113101":"高丽营镇","110113104":"李桥镇","110113105":"李遂镇","110113106":"南彩镇","110113108":"北务镇","110113109":"大孙各庄镇","110113110":"张镇","110113111":"龙湾屯镇","110113112":"木林镇","110113113":"北小营镇","110113115":"北石槽镇","110113116":"赵全营镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110113.json
// module id = 31
// module chunks = 0